import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './layout.scss';
import MenuHeader from './MenuHeader';
import Breadcrumb from './Breadcrumb';
import { BreadcrumbProvider } from './BreadcrumbContext';

const AppLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Auth guard: protected routes require a token. If it is cleared — by logout,
  // the 401 handler in baseQuery (which fires `auth:logout`), or another tab —
  // send the user back to the login page.
  useEffect(() => {
    const redirectIfLoggedOut = () => {
      if (!localStorage.getItem('token')) {
        navigate('/', { replace: true });
      }
    };

    // Check on mount / on every navigation to a protected route.
    redirectIfLoggedOut();

    // React instantly to same-tab clears (logout / 401) and other-tab clears.
    window.addEventListener('auth:logout', redirectIfLoggedOut);
    window.addEventListener('storage', redirectIfLoggedOut);
    return () => {
      window.removeEventListener('auth:logout', redirectIfLoggedOut);
      window.removeEventListener('storage', redirectIfLoggedOut);
    };
  }, [location.pathname, navigate]);

  return (
    <BreadcrumbProvider>
      <div className="app-layout">
        <Header />
        <MenuHeader />
        <main className="app-main container-fluid">
          <Breadcrumb />
          {/* Key the routed page by pathname so every menu opens fresh.
              Some components (e.g. VacancyUpdate) are mapped to more than one
              route; without this key React reuses the same instance across those
              menus and leaks the previous screen's state. Changing the key
              forces a clean unmount/remount on each navigation. */}
          <Outlet key={location.pathname} />
        </main>
        <Footer />
      </div>
    </BreadcrumbProvider>
  );
};

export default AppLayout;
